// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type Options as Options2,
  type TDataShape,
  urlSearchParamsBodySerializer,
} from './client'
import { client } from './client.gen'
import type {
  CreatePartnerProfileUsingPostData,
  CreatePartnerProfileUsingPostErrors,
  CreatePartnerProfileUsingPostResponses,
  CreateSessionUsingPostData,
  CreateSessionUsingPostErrors,
  CreateSessionUsingPostResponses,
  GetLogoutForMvpdUsingGetData,
  GetLogoutForMvpdUsingGetErrors,
  GetLogoutForMvpdUsingGetResponses,
  GetProfileForCodeUsingGet1Data,
  GetProfileForCodeUsingGet1Errors,
  GetProfileForCodeUsingGet1Responses,
  GetProfileForMvpdUsingGetData,
  GetProfileForMvpdUsingGetErrors,
  GetProfileForMvpdUsingGetResponses,
  GetProfilesUsingGet1Data,
  GetProfilesUsingGet1Errors,
  GetProfilesUsingGet1Responses,
  GetSessionStatusUsingGet1Data,
  GetSessionStatusUsingGet1Errors,
  GetSessionStatusUsingGet1Responses,
  HandleRequestUsingGetData,
  HandleRequestUsingGetErrors,
  HandleRequestUsingGetResponses,
  ResumeSessionUsingPostData,
  ResumeSessionUsingPostErrors,
  ResumeSessionUsingPostResponses,
  RetrieveAuthorizeDecisionsForMvpdUsingPostData,
  RetrieveAuthorizeDecisionsForMvpdUsingPostErrors,
  RetrieveAuthorizeDecisionsForMvpdUsingPostResponses,
  RetrievePreAuthorizeDecisionsForMvpdUsingPost1Data,
  RetrievePreAuthorizeDecisionsForMvpdUsingPost1Errors,
  RetrievePreAuthorizeDecisionsForMvpdUsingPost1Responses,
  RetrieveVerificationTokenUsingPostData,
  RetrieveVerificationTokenUsingPostErrors,
  RetrieveVerificationTokenUsingPostResponses,
  StartAuthenticationUsingGetData,
  StartAuthenticationUsingGetErrors,
  StartAuthenticationUsingGetResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export class Decisions {
  /**
   * Retrieve authorization decisions using specific MVPD
   */
  public static retrieveAuthorizeDecisionsForMvpdUsingPost<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      RetrieveAuthorizeDecisionsForMvpdUsingPostData,
      ThrowOnError
    >,
  ) {
    return (options.client ?? client).post<
      RetrieveAuthorizeDecisionsForMvpdUsingPostResponses,
      RetrieveAuthorizeDecisionsForMvpdUsingPostErrors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/decisions/authorize/{mvpd}',
      ...options,
    })
  }

  /**
   * Retrieve preauthorization decisions using specific MVPD
   */
  public static retrievePreAuthorizeDecisionsForMvpdUsingPost1<
    ThrowOnError extends boolean = false,
  >(
    options: Options<
      RetrievePreAuthorizeDecisionsForMvpdUsingPost1Data,
      ThrowOnError
    >,
  ) {
    return (options.client ?? client).post<
      RetrievePreAuthorizeDecisionsForMvpdUsingPost1Responses,
      RetrievePreAuthorizeDecisionsForMvpdUsingPost1Errors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/decisions/preauthorize/{mvpd}',
      ...options,
    })
  }
}

export class Logout {
  /**
   * Initiate logout for specific MVPD
   */
  public static getLogoutForMvpdUsingGet<ThrowOnError extends boolean = false>(
    options: Options<GetLogoutForMvpdUsingGetData, ThrowOnError>,
  ) {
    return (options.client ?? client).get<
      GetLogoutForMvpdUsingGetResponses,
      GetLogoutForMvpdUsingGetErrors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/logout/{mvpd}',
      ...options,
    })
  }
}

export class Profiles {
  /**
   * Retrieve profiles for specific code
   */
  public static getProfileForCodeUsingGet1<
    ThrowOnError extends boolean = false,
  >(options: Options<GetProfileForCodeUsingGet1Data, ThrowOnError>) {
    return (options.client ?? client).get<
      GetProfileForCodeUsingGet1Responses,
      GetProfileForCodeUsingGet1Errors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/profiles/code/{code}',
      ...options,
    })
  }

  /**
   * Retrieve profiles
   */
  public static getProfilesUsingGet1<ThrowOnError extends boolean = false>(
    options: Options<GetProfilesUsingGet1Data, ThrowOnError>,
  ) {
    return (options.client ?? client).get<
      GetProfilesUsingGet1Responses,
      GetProfilesUsingGet1Errors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/profiles',
      ...options,
    })
  }

  /**
   * Retrieve profiles for specific MVPD
   */
  public static getProfileForMvpdUsingGet<ThrowOnError extends boolean = false>(
    options: Options<GetProfileForMvpdUsingGetData, ThrowOnError>,
  ) {
    return (options.client ?? client).get<
      GetProfileForMvpdUsingGetResponses,
      GetProfileForMvpdUsingGetErrors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/profiles/{mvpd}',
      ...options,
    })
  }
}

export class Sessions {
  /**
   * Perform authentication in user agent
   */
  public static startAuthenticationUsingGet<
    ThrowOnError extends boolean = false,
  >(options: Options<StartAuthenticationUsingGetData, ThrowOnError>) {
    return (options.client ?? client).get<
      StartAuthenticationUsingGetResponses,
      StartAuthenticationUsingGetErrors,
      ThrowOnError
    >({
      url: '/authenticate/{serviceProvider}/{code}',
      ...options,
    })
  }

  /**
   * Create authentication session
   */
  public static createSessionUsingPost<ThrowOnError extends boolean = false>(
    options: Options<CreateSessionUsingPostData, ThrowOnError>,
  ) {
    return (options.client ?? client).post<
      CreateSessionUsingPostResponses,
      CreateSessionUsingPostErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      url: '/{serviceProvider}/sessions',
      ...options,
    })
  }

  /**
   * Retrieve authentication session using code
   */
  public static getSessionStatusUsingGet1<ThrowOnError extends boolean = false>(
    options: Options<GetSessionStatusUsingGet1Data, ThrowOnError>,
  ) {
    return (options.client ?? client).get<
      GetSessionStatusUsingGet1Responses,
      GetSessionStatusUsingGet1Errors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/sessions/{code}',
      ...options,
    })
  }

  /**
   * Resume authentication session
   */
  public static resumeSessionUsingPost<ThrowOnError extends boolean = false>(
    options: Options<ResumeSessionUsingPostData, ThrowOnError>,
  ) {
    return (options.client ?? client).post<
      ResumeSessionUsingPostResponses,
      ResumeSessionUsingPostErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      url: '/{serviceProvider}/sessions/{code}',
      ...options,
    })
  }
}

export class Configuration {
  /**
   * Retrieve configuration for specific service provider
   */
  public static handleRequestUsingGet<ThrowOnError extends boolean = false>(
    options: Options<HandleRequestUsingGetData, ThrowOnError>,
  ) {
    return (options.client ?? client).get<
      HandleRequestUsingGetResponses,
      HandleRequestUsingGetErrors,
      ThrowOnError
    >({
      url: '/{serviceProvider}/configuration',
      ...options,
    })
  }
}

export class PartnerSingleSignOn {
  /**
   * Retrieve profile using partner authentication response
   */
  public static createPartnerProfileUsingPost<
    ThrowOnError extends boolean = false,
  >(options: Options<CreatePartnerProfileUsingPostData, ThrowOnError>) {
    return (options.client ?? client).post<
      CreatePartnerProfileUsingPostResponses,
      CreatePartnerProfileUsingPostErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      url: '/{serviceProvider}/profiles/sso/{partner}',
      ...options,
    })
  }

  /**
   * Retrieve partner authentication request
   */
  public static retrieveVerificationTokenUsingPost<
    ThrowOnError extends boolean = false,
  >(options: Options<RetrieveVerificationTokenUsingPostData, ThrowOnError>) {
    return (options.client ?? client).post<
      RetrieveVerificationTokenUsingPostResponses,
      RetrieveVerificationTokenUsingPostErrors,
      ThrowOnError
    >({
      ...urlSearchParamsBodySerializer,
      url: '/{serviceProvider}/sessions/sso/{partner}',
      ...options,
    })
  }
}
